import { ReactNode } from "react";
import { CollateralMintName } from "../../../config/solana.types";
import { FormAddon } from "../form/Form";
import CollateralForm, { Props as CollateralFormProps } from "./CollateralForm";
import CollateralFormInput from "./CollateralFormInput";

type Props = Omit<CollateralFormProps, "children"> & {
  onCollateralMintChange?: (newCollateralMintName: CollateralMintName) => void;
  onCollateralAmountChange: (amount: string) => void;
  onRedeemableAmountChange: (amount: string) => void;
  collateralAmount: string;
  redeemableAmount: string;
  connected: boolean;
  children?: ReactNode;
};

const FromCollateralForm = ({
  onCollateralMintChange,
  onCollateralAmountChange,
  onRedeemableAmountChange,
  collateralAmount,
  redeemableAmount,
  connected,
  children,
  ...formProps
}: Props) => {
  return (
    <CollateralForm {...formProps}>
      {({ collateral, redeemable, availableCollateralMints }) => {
        return (
          <>
            <CollateralFormInput
              id="collateral-amount-input"
              name="collateral-amount"
              label="From"
              value={collateralAmount}
              handleChange={onCollateralAmountChange}
              maxButtonEnabled={true}
              connected={connected}
              mintInfo={collateral}
              availableMints={availableCollateralMints}
              handleMintChange={onCollateralMintChange}
            />
            {children ? (
              <FormAddon className="CollateralForm">{children}</FormAddon>
            ) : null}
            <CollateralFormInput
              id="redeemable-amount-input"
              name="redeemable-amount"
              label="To"
              value={redeemableAmount}
              handleChange={onRedeemableAmountChange}
              maxButtonEnabled={false}
              connected={connected}
              mintInfo={redeemable}
            />
          </>
        );
      }}
    </CollateralForm>
  );
};

export default FromCollateralForm;
